export enum ReliabilityPrematureFailureReasonType {
  Misuse = 1,
  Nff = 2,
  Cid = 3,
  CustomerOriginatedComponent = 4,
  TsiNotZero = 5,
  Other = 6,
}

export const ReliabilityPrematureFailureRejectReasonType = [
  { key: "MISUSE", value: ReliabilityPrematureFailureReasonType.Misuse },
  { key: "NFF", value: ReliabilityPrematureFailureReasonType.Nff },
  { key: "CID", value: ReliabilityPrematureFailureReasonType.Cid },
  { key: "OTHER", value: ReliabilityPrematureFailureReasonType.Other },
];

export const ReliabilityNotPrematureFailureReasonType = [
  { key: "CUSTOMER ORIGINATED COMPONENT", value: ReliabilityPrematureFailureReasonType.CustomerOriginatedComponent },
  { key: "TSI > 500", value: ReliabilityPrematureFailureReasonType.TsiNotZero },
  { key: "OTHER", value: ReliabilityPrematureFailureReasonType.Other },
];

export const ReliabilityPrematureFailureReasonChoices = [
  ...ReliabilityPrematureFailureRejectReasonType,
  ...ReliabilityNotPrematureFailureReasonType,
];
